import React, { useEffect } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Input, Label, Form, FormFeedback } from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { registerUser, apiError } from "../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";

// import images
import logolight from '../../assets/images/logo-light.png';
import logodark from '../../assets/images/logo-dark.png';
import { useNavigate } from "react-router-dom";

const Register = props => {
    document.title = "Register | Definite Assurance Company Limited";
    const navigate = useNavigate()



  const toLogin =()=>{
    navigate('/login')
  }

  return (
    <div className="bg-pattern" style={{height:"150vh"}}>
    <div className="bg-overlay"></div>
    <div className="account-pages pt-5">
        <Container>
            <Row className="justify-content-center">
                <Col lg={6} md={8} xl={4}>
                    <Card className='mt-5'>
                        <CardBody className="p-4">
                        <div className="text-center">
                            <img src="/definitelogo.png" alt="" className="loginLogo" />
                            </div>
                            
                            <p className="mb-5 text-center">
                                Sign up with Definite Assurance.
                            </p>
                           
                                <Row>
                                    <Col md={12}>
                                    <div className="mb-4">
                                        <Label className="form-label">Account type</Label>
                                            <select  className="form-label">
                                                <option selected disabled>Account type</option>
                                                <option >Customer</option>
                                                <option >Intermediary</option>
                                            </select>
                                        </div>
                                        <div className="mb-4">
                                        <Label className="form-label">Fullname</Label>
                                            <Input
                                            id="name"
                                            name="name"
                                            className="form-control"
                                            placeholder="Enter fullname"
                                            type="text"
                                            />
                                        </div>
                                        <div className="mb-4">
                                        <Label className="form-label">Email</Label>
                                            <Input
                                            id="email"
                                            name="email"
                                            className="form-control"
                                            placeholder="Enter email"
                                            type="email"
                                            />
                                        </div>
                                        <div className="mb-4">
                                        <Label className="form-label">Phone</Label>
                                            <Input
                                            id="phone"
                                            name="phone"
                                            className="form-control"
                                            placeholder="Enter Phone number"
                                            type="text"
                                            />
                                        </div>

                                        <div className="mb-4">
                                        <Label className="form-label">Password</Label>
                                            <Input
                                            name="password"
                                            type="password"
                                            placeholder="Enter Password"
                                           />
                                        </div>
                                        <div className="mb-4">
                                        <Label className="form-label">Confirm Password</Label>
                                            <Input
                                            name="password"
                                            type="password"
                                            placeholder="Enter Password"
                                           />
                                        </div>
                                        <div className="form-check">
                                            <input type="checkbox" className="form-check-input" id="term-conditionCheck" />
                                            <label className="form-check-label fw-normal" htmlFor="term-conditionCheck">I accept <Link to="#" className="text-primary">Terms and Conditions</Link></label>
                                        </div>
                                        <div className="d-grid mt-4">
                                            <button  style={{backgroundColor:'red',color:"white",fontWeight:"500"}} className="btn btn-primary waves-effect waves-light" onClick={toLogin}>Register</button>
                                        </div>
                                    </Col>
                                </Row>
                           
                        </CardBody>
                    </Card>
                    <div className="mt-5 text-center">
                        <p className="text-white-50">Already have an account ?<Link to="/login" className="fw-medium text-primary"> Login </Link> </p>
                        <p className="text-white-50">© {new Date().getFullYear()} Definite Assurance Company Limited.</p>
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
</div>
  );
};

export default Register;
